/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetAllocationCategory } from './AssetAllocationCategory';
import {
    AssetAllocationCategoryFromJSON,
    AssetAllocationCategoryFromJSONTyped,
    AssetAllocationCategoryToJSON,
} from './AssetAllocationCategory';
import type { AssetAllocationSource } from './AssetAllocationSource';
import {
    AssetAllocationSourceFromJSON,
    AssetAllocationSourceFromJSONTyped,
    AssetAllocationSourceToJSON,
} from './AssetAllocationSource';

/**
 * 
 * @export
 * @interface AssetAllocationItem
 */
export interface AssetAllocationItem {
    /**
     * 
     * @type {string}
     * @memberof AssetAllocationItem
     */
    tradeDate: string;
    /**
     * 
     * @type {AssetAllocationCategory}
     * @memberof AssetAllocationItem
     */
    category: AssetAllocationCategory;
    /**
     * 
     * @type {AssetAllocationSource}
     * @memberof AssetAllocationItem
     */
    source: AssetAllocationSource;
    /**
     * 
     * @type {number}
     * @memberof AssetAllocationItem
     */
    value?: number;
}



/**
 * Check if a given object implements the AssetAllocationItem interface.
 */
export function instanceOfAssetAllocationItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function AssetAllocationItemFromJSON(json: any): AssetAllocationItem {
    return AssetAllocationItemFromJSONTyped(json, false);
}

export function AssetAllocationItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAllocationItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeDate': json['trade_date'],
        'category': AssetAllocationCategoryFromJSON(json['category']),
        'source': AssetAllocationSourceFromJSON(json['source']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function AssetAllocationItemToJSON(value?: AssetAllocationItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_date': value.tradeDate,
        'category': AssetAllocationCategoryToJSON(value.category),
        'source': AssetAllocationSourceToJSON(value.source),
        'value': value.value,
    };
}

